import React, { useEffect, useState } from 'react'
import './charts-section.styles.css'
import { SlArrowLeft, SlArrowRight, SlCalender } from 'react-icons/sl'
import ChartPage from '../../components/chart-section/chart.component'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { Container, Row, Col, Button } from 'react-bootstrap';

const ChartsSection = ({ handleDates, handleTableData }) => {
  // تاریخ جاری
  const today = new Date()

  // تاریخ‌های پیش‌فرض
  const [showDatePicker, setShowDatePicker] = useState(false)
  const [startDate, setStartDate] = useState(today) // تاریخ جاری به عنوان تاریخ شروع
  const [endDate, setEndDate] = useState(today) // تاریخ جاری به عنوان تاریخ پایان
  const [reloadCharts, setReloadCharts] = useState(true)

  const handleDateApply = () => {
    setShowDatePicker(false)
    // console.log('Selected Start Date:', startDate)
    // console.log('Selected End Date:', endDate)

    setReloadCharts(true)
  }

  handleDates(startDate, endDate);

  useEffect(() => {
    handleDates(startDate, endDate);
  }, [startDate, endDate]);

  const handleReloadCharts = (value) => {
    setReloadCharts(value)
  }

  const handleStartDate = (date) => {
    setStartDate(date)
  }

  const handleEndDate = (date) => {
    setEndDate(date)
  }

  let quickRanges = [
    {
      title: 'Last 2 days',
      value: { start: new Date(today.getTime() - 2 * 24 * 60 * 60 * 1000), end: today },
    },
    {
      title: 'Yesterday',
      value: { start: new Date(today.getTime() - 24 * 60 * 60 * 1000), end: new Date(today.getTime() - 24 * 60 * 60 * 1000) },
    },
    {
      title: 'Today',
      value: { start: today, end: today },
    },
    // {
    //   title: 'Last hour',
    //   value: { start: new Date(today.getTime() - 60 * 60 * 1000), end: today },
    // },

    {
      title: 'Last 7 days',
      value: { start: new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000), end: today },
    },
    {
      title: 'Day before',
      value: { start: new Date(today.getTime() - 24 * 60 * 60 * 1000), end: new Date(today.getTime() - 24 * 60 * 60 * 1000) },
    },
    {
      title: 'This week',
      value: { start: new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000), end: today },
    },
    // {
    //   title: 'Last 3 hours',
    //   value: { start: new Date(today.getTime() - 3 * 60 * 60 * 1000), end: today },
    // },

    {
      title: 'Last 30 days',
      value: { start: new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000), end: today },
    },
    {
      title: 'This day last week',
      value: { start: new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000), end: new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000) },
    },
    {
      title: 'This month',
      value: { start: new Date(today.getFullYear(), today.getMonth(), 1), end: today },
    },
    // {
    //   title: 'Last 6 hours',
    //   value: { start: new Date(today.getTime() - 6 * 60 * 60 * 1000), end: today },
    // },

    {
      title: 'Last 90 days',
      value: { start: new Date(today.getTime() - 90 * 24 * 60 * 60 * 1000), end: today },
    },
    {
      title: 'Previous month',
      value: { start: new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000), end: new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000) },
    },
    {
      title: 'This year',
      value: { start: new Date(today.getFullYear(), 0, 1), end: today },
    },
    {
      title: 'Last 12 months',
      value: { start: new Date(today.getFullYear() - 1, 0, 1), end: today },
    },

    {
      title: 'Last 6 months',
      value: { start: new Date(today.getFullYear() - 1, 0, 1), end: today },
    },
    {
      title: 'Previous week',
      value: { start: new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000), end: new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000) },
    },
    // {
    //   title: 'Last 12 hours',
    //   value: { start: new Date(today.getTime() - 12 * 60 * 60 * 1000), end: today },
    // },
    // {
    //   title: 'Last 24 hours',
    //   value: { start: new Date(today.getTime() - 24 * 60 * 60 * 1000), end: today },
    // },
  ];

  let futures = [
    {
      title: 'Tomorrow',
      value: { start: new Date(today.getTime() + 24 * 60 * 60 * 1000), end: new Date(today.getTime() + 24 * 60 * 60 * 1000) },
    },
    {
      title: 'Day after tomorrow',
      value: { start: new Date(today.getTime() + 2 * 24 * 60 * 60 * 1000), end: new Date(today.getTime() + 2 * 24 * 60 * 60 * 1000) },
    },
    {
      title: 'Next 2 days',
      value: { start: new Date(today.getTime() + 2 * 24 * 60 * 60 * 1000), end: new Date(today.getTime() + 2 * 24 * 60 * 60 * 1000) },
    },
    {
      title: 'Next 7 days',
      value: { start: new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000), end: new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000) },
    }
  ];

  return (
    <div className='charts-section'>
      <div className='charts-section-title-wrapper'>
        <h2 className='page-title'>Charts</h2>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <button
            className='dashboard-calender-button me-3'
            onClick={() => { setStartDate(new Date(startDate.getTime() - 24 * 60 * 60 * 1000)); setEndDate(new Date(startDate.getTime() - 24 * 60 * 60 * 1000)); setReloadCharts(true); }}
          >
            <SlArrowLeft />
          </button>
          <button
            className='dashboard-calender-button me-3'
            onClick={() => setShowDatePicker(!showDatePicker)}
          >
            <SlCalender />
            {startDate.toLocaleDateString() == endDate.toLocaleDateString() ? startDate.toLocaleDateString() : `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`}
          </button>
          <button
            className='dashboard-calender-button'
            onClick={() => { setStartDate(new Date(startDate.getTime() + 24 * 60 * 60 * 1000)); setEndDate(new Date(startDate.getTime() + 24 * 60 * 60 * 1000)); setReloadCharts(true); }}
          >
            <SlArrowRight />
          </button>
        </div>
      </div>

      {/* نمایش تقویم */}
      {showDatePicker && (
        <div className='date-picker-wrapper'>
          {/* <div>
            <label>Start Date:</label>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              dateFormat='yyyy-MM-dd'
            />
          </div>
          <div>
            <label>End Date:</label>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              dateFormat='yyyy-MM-dd'
            />
          </div>
          <button onClick={handleDateApply}>Apply Dates</button> */}
          <Container>
            <Row>
              <Col xs={12} sm={8} md={8} lg={8}>
                <h2>Quick ranges</h2>
                <Row>
                  {quickRanges.map((range, index) => (
                    <Col
                      key={index}
                      xs={12}
                      sm={4}
                      md={4}
                      lg={4}
                    >
                      <Button className='d-block w-100 btn bg-secondary bg-opacity-50 text-black' onClick={() => {
                        setStartDate(range.value.start);
                        setEndDate(range.value.end);

                        setReloadCharts(true);
                        setShowDatePicker(false);
                      }}>{range.title}</Button>
                    </Col>
                  ))}
                </Row>
                <h3 className='mt-5'>Future</h3>
                <Row>
                  {futures.map((range, index) => (
                    <Col
                      key={index}
                      xs={12}
                      sm={3}
                      md={3}
                      lg={3}
                    >
                      <Button className='d-block w-100 btn bg-secondary bg-opacity-50 text-black' onClick={() => {
                        setStartDate(range.value.start);
                        setEndDate(range.value.end);

                        setReloadCharts(true);
                        setShowDatePicker(false);
                      }}>{range.title}</Button>
                    </Col>
                  ))}
                </Row>
              </Col>
              <Col xs={12} sm={4} md={4} lg={4}>
                <h2>Custom</h2>
                <div>
                  <label>Start Date:</label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    dateFormat='yyyy-MM-dd'
                    className='form-control'
                  />
                </div>
                <div className='mt-3'>
                  <label>End Date:</label>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    dateFormat='yyyy-MM-dd'
                    className='form-control'
                  />
                </div>
                <button onClick={handleDateApply} className='btn btn-primary mt-3'>Apply Dates</button>
              </Col>
            </Row>
          </Container>
        </div>
      )}

      {/* نمایش نمودارها */}
      <div className='chart-wrapper'>
        <ChartPage
          title='Battery Power Chart'
          chartType='batteryPower'
          startDate={startDate}
          endDate={endDate}
          reloadCharts={reloadCharts}
          handleReloadCharts={handleReloadCharts}
          handleStartDate={handleStartDate}
          handleEndDate={handleEndDate}
          handleTableData={handleTableData}
        />
      </div>
      <div className='chart-wrapper'>
        <ChartPage
          title='Load Voltages Chart'
          chartType='loadVoltages'
          startDate={startDate}
          endDate={endDate}
          reloadCharts={reloadCharts}
          handleReloadCharts={handleReloadCharts}
          handleStartDate={handleStartDate}
          handleEndDate={handleEndDate}
          handleTableData={handleTableData}
        />
      </div>
      <div className='chart-wrapper'>
        <ChartPage
          title='Battery Voltage Chart'
          chartType='batteryVoltage'
          startDate={startDate}
          endDate={endDate}
          reloadCharts={reloadCharts}
          handleReloadCharts={handleReloadCharts}
          handleStartDate={handleStartDate}
          handleEndDate={handleEndDate}
          handleTableData={handleTableData}
        />
      </div>
      <div className='chart-wrapper'>
        <ChartPage
          title='Status Chart'
          chartType='statusChart'
          startDate={startDate}
          endDate={endDate}
          reloadCharts={reloadCharts}
          handleReloadCharts={handleReloadCharts}
          handleStartDate={handleStartDate}
          handleEndDate={handleEndDate}
          handleTableData={handleTableData}
        />
      </div>
    </div>
  )
}

export default ChartsSection
